import { __assign, __values } from "tslib";
import { mapMoloItems } from '../models/MoloItem';
import { uniq } from 'lodash';
export function getProductCategories(orderlines, dividers) {
    var e_1, _a;
    var groupings = {};
    if (!orderlines.length) {
        return {};
    }
    var _loop_1 = function (i) {
        var divider = dividers[i];
        var _loop_2 = function (key_1) {
            var orderline = orderlines[key_1];
            if (!groupings[divider.id]) {
                groupings[divider.id] = {};
            }
            if (divider.id !== 'sustainability') {
                var linesWith = orderlines.filter(function (line) {
                    return line[divider.valueKey] === orderline[divider.valueKey];
                });
                if (linesWith.length) {
                    groupings[divider.id][orderline[divider.valueKey]] = {
                        orderLines: linesWith,
                        title: divider.id === 'collection' ? orderline[divider.labelKey].toUpperCase() : orderline[divider.labelKey],
                        value: orderline[divider.valueKey],
                        colorBlocked: orderline.colorBlocked || false,
                        quantity: ((groupings[divider.id][orderline[divider.valueKey]] && groupings[divider.id][orderline[divider.valueKey]].quantity) || 0) + orderline.quantity,
                        revenue: ((groupings[divider.id][orderline[divider.valueKey]] && groupings[divider.id][orderline[divider.valueKey]].revenue) || 0) + orderline.amount,
                        salesOptions: 0,
                    };
                }
            }
            else {
                var valueKey_1 = null;
                console.log('bolaresen valueKey ' + valueKey_1);
                if (orderline.organic == true)
                    valueKey_1 = 'organic';
                if (orderline.ecovero == true)
                    valueKey_1 = 'ecovero';
                if (orderline.recycled == true)
                    valueKey_1 = 'recycled';
                if (orderline.oekotex !== '')
                    valueKey_1 = 'oekoTex';
                if (orderline.ocsno !== '')
                    valueKey_1 = 'ocs_100';
                if (orderline.grsno !== '')
                    valueKey_1 = 'grs';
                if (orderline.gots !== '')
                    valueKey_1 = 'gots';
                if (valueKey_1 == null) {
                    console.log('bolaresen valueKey nothing', orderline);
                }
                else {
                    console.log('bolaresen valueKey 2 ' + valueKey_1, orderline);
                }
                if (valueKey_1) {
                    var linesWith = orderlines.filter(function (line) {
                        if (valueKey_1 === 'gots') {
                            if (line.gots !== '')
                                return true;
                        }
                        if (valueKey_1 === 'oekoTex') {
                            if (line.oekotex !== '')
                                return true;
                        }
                        if (valueKey_1 === 'recycled') {
                            if (line.recycled)
                                return true;
                        }
                        if (valueKey_1 === 'organic') {
                            if (line.organic)
                                return true;
                        }
                        if (valueKey_1 === 'ecovero') {
                            if (line.ecovero)
                                return true;
                        }
                        if (valueKey_1 === 'ocs_100') {
                            if (line.OCSno !== '')
                                return true;
                        }
                        if (valueKey_1 === 'grs') {
                            if (line.grsno)
                                return true;
                        }
                        return false;
                    });
                    if (linesWith.length) {
                        groupings[divider.id][valueKey_1] = {
                            orderLines: linesWith,
                            title: valueKey_1.toUpperCase(),
                            value: valueKey_1,
                            colorBlocked: orderline.colorBlocked || false,
                            quantity: ((groupings[divider.id][valueKey_1] && groupings[divider.id][valueKey_1].quantity) || 0) + orderline.quantity,
                            revenue: ((groupings[divider.id][valueKey_1] && groupings[divider.id][valueKey_1].revenue) || 0) + orderline.amount,
                            salesOptions: 0,
                        };
                    }
                }
            }
        };
        for (var key_1 in orderlines) {
            _loop_2(key_1);
        }
    };
    for (var i in dividers) {
        _loop_1(i);
    }
    for (var groupKey in groupings) {
        for (var key in groupings[groupKey]) {
            var grouped = {};
            var orderLines = groupings[groupKey][key].orderLines;
            try {
                for (var orderLines_1 = (e_1 = void 0, __values(orderLines)), orderLines_1_1 = orderLines_1.next(); !orderLines_1_1.done; orderLines_1_1 = orderLines_1.next()) {
                    var orderLine = orderLines_1_1.value;
                    var key_2 = String(orderLine.masterId + orderLine.colorCode);
                    if (!grouped[key_2]) {
                        grouped[key_2] = [];
                    }
                    grouped[key_2].push(orderLine);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (orderLines_1_1 && !orderLines_1_1.done && (_a = orderLines_1.return)) _a.call(orderLines_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            groupings[groupKey][key]['salesOptions'] = Object.keys(grouped).length;
        }
    }
    return groupings;
}
export function getDeliveryWindows(orderLines) {
    var deliveryWindows = [];
    var windows = {};
    for (var i in orderLines) {
        windows[orderLines[i].deliveryCode] = {
            shippingDate: orderLines[i].deliveryshiptmentdate,
            deliveryCode: orderLines[i].deliveryCode,
            delivreryShortdescription: orderLines[i].delivreryshortdescription,
        };
    }
    for (var i in windows) {
        deliveryWindows.push(windows[i]);
    }
    return deliveryWindows;
}
export function groupSimilarColors(orderLines) {
    var grouped = {};
    var sizes = {};
    for (var i in orderLines) {
        var orderline = orderLines[i];
        var masterid = orderline.masterid;
        var colorcode = orderline.colorcode;
        if (grouped[masterid + colorcode]) {
            var q = +grouped[masterid + colorcode].quantity + +orderline.quantity;
            grouped[masterid + colorcode].quantity = q;
            grouped[masterid + colorcode]['orderLines'].push(__assign({}, orderline));
        }
        else {
            grouped[masterid + colorcode] = orderline;
            grouped[masterid + colorcode]['orderLines'] = [__assign({}, orderline)];
        }
        if (!sizes[masterid + colorcode]) {
            sizes[masterid + colorcode] = [];
        }
        sizes[masterid + colorcode].push({
            sizename: orderline.sizename,
            quantity: orderline.quantity,
            price: orderline.whp,
        });
    }
    var g = [];
    for (var key in grouped) {
        var line = grouped[key];
        var q = 0;
        for (var delta in line['orderLines']) {
            q = q + line['orderLines'][delta].quantity;
        }
        line.quantity = q;
        g.push(line);
    }
    var sorted = g.sort(function (a, b) { return (a.masterid > b.masterid) ? 1 : -1; });
    return sorted;
}
export function getSizes(orderLines) {
    var grouped = {};
    var sizes = {};
    for (var i in orderLines) {
        var orderline = orderLines[i];
        var masterid = orderline.masterid;
        var colorcode = orderline.colorcode;
        if (!sizes[masterid + colorcode]) {
            sizes[masterid + colorcode] = [];
        }
        sizes[masterid + colorcode].push({
            sizename: orderline.sizename,
            quantity: orderline.quantity,
            price: orderline.whp,
        });
    }
    return sizes;
}
export function getRRPMap(moloItems) {
    var rrpMap = {};
    for (var key in moloItems) {
        var items = mapMoloItems(moloItems[key]);
        rrpMap[items[0].masterId + items[0].colorCode] = uniq(items.map(function (item) { return item.msrp; }));
    }
    return rrpMap;
}
export function getAllSizes(moloItems, sizes) {
    var allSizes = {};
    for (var key in moloItems) {
        var items = mapMoloItems(moloItems[key]);
        if (!allSizes[items[0].masterId + items[0].colorCode]) {
            allSizes[items[0].masterId + items[0].colorCode] = [];
        }
        var _loop_3 = function (i) {
            var item = items[i];
            var quantity = 0;
            if (sizes[items[0].masterId + items[0].colorCode]) {
                var found = sizes[items[0].masterId + items[0].colorCode].find(function (i) {
                    return i.sizename === item.sizeName;
                });
                if (!!found) {
                    quantity = found.quantity;
                }
            }
            allSizes[items[0].masterId + items[0].colorCode].push({
                sizename: item.sizeName,
                quantity: quantity,
                price: item.whp,
            });
        };
        for (var i in items) {
            _loop_3(i);
        }
    }
    return allSizes;
}
export function getGroupedMoloItems(data) {
    // IgroupedItems
    var moloItems = {};
    for (var key in data) {
        var item = data[key];
        if (!moloItems[item.masterno + item.colorcode]) {
            moloItems[item.masterno + item.colorcode] = [];
        }
        moloItems[item.masterno + item.colorcode].push(item);
    }
    return moloItems;
}
//# sourceMappingURL=DashboardHelper.js.map